import api from '../api';
import { toast } from 'react-toastify';
import messageTypes from '../../constants/MessagesTypes';

export async function getCompanies(data) {
  return api.get(`/api/company`, {
    params: data,
    headers: {
      auth: true
    },
  }).catch((error) => {
    toast.error(messageTypes.ERROR_LOAD);
    return [];
  });
}

export async function getCurrentCompany() {
  return api.get(`/api/company/current`, {
    headers: {
      auth: true
    },
  }).catch((error) => {
    return null;
  });
}

export async function getCompany(id) {
  return api.get(`/api/company/${id}`, {
    headers: {
      auth: true
    },
  }).catch((error) => {
    toast.error(error.response?.data?.message || messageTypes.ERROR_LOAD);
    throw error;
  });
}

export async function createCompany(data) {
  return api.post(`/api/company/new`, data, {
    headers: {
      'Content-Type': 'application/json',
      auth: true
    },
  }).catch((error) => {
    toast.error(error.response?.data?.message || messageTypes.ERROR_SAVE);
    throw error;
  });
}

export async function updateCompany(id, data) {
  return api.put(`/api/company/${id}/edit`, data, {
    headers: {
      'Content-Type': 'application/json',
      auth: true
    },
  }).catch((error) => {
    toast.error(error.response?.data?.message || messageTypes.ERROR_UPDATE);
    throw error;
  });
}

export async function deleteCompany(id) {
  return api.delete(`/api/company/${id}/delete`, {
    headers: {
      auth: true
    },
  }).catch((error) => {
    toast.error(error.response?.data?.message || messageTypes.ERROR_DELETE);
    throw error;
  });
}

